
import QuestionIcon from "@/components/icons/QuestionIcon.vue";
import CommunicationIcon from "@/components/icons/CommunicationIcon.vue";
import PhoneIcon from "@/components/icons/PhoneIcon.vue";
import { defineComponent } from "vue";
import { FormTypes } from "@/improvementForms/formTypes";
import ImprovementFormModal from "@/improvementForms/ImprovementFormModal.vue";

export default defineComponent({
  data() {
    return { FormTypes };
  },
  components: {
    ImprovementFormModal,
    QuestionIcon,
    CommunicationIcon,
    PhoneIcon,
  },
});
